import {
  Flex,
  Modal,
  Modal as ModalMantine,
  Text,
  Title,
  useMantineTheme,
} from "@mantine/core";
import { ArrowDown, DirectDown } from "iconsax-react";
import Heading from "../../Heading";

interface IProps {
  title?: string;
  open: boolean;
  setClose: () => void;
  children: React.ReactNode;
}

const ModalVideo = ({ title, open, setClose, children }: IProps) => {
  const theme = useMantineTheme();
  return (
    <ModalMantine
      size="auto"
      opened={open}
      onClose={setClose}
      transitionProps={{
        exitDuration: 600,
        transition: "slide-up",
        duration: 600,
        timingFunction: "ease",
      }}
      withCloseButton={false}
      centered
      styles={{
        content: {
          borderRadius: "12px",
          minWidth: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "start",
          height: "100%",
        },
        inner: {
          zIndex: 1000,
          paddingLeft: "10vw !important",
          paddingRight: "10vw !important",
          paddingTop: "10vh !important",
          paddingBottom: "10vh !important",
        },
        overlay: { zIndex: 999 },
        header: {
          marginBottom: "0",
          background: "transparent",
          padding: "20px 0",
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
        },
        close: {
          display: "flex",
          height: "28px",
          width: "28px",
          justifyContent: "center",
          alignItems: "center",
          svg: {
            height: "24px !important",
            width: "24px !important",
          },
        },
        body: {
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          backgroundColor: "#fff",
          borderRadius: "50px 50px 12px 12px",
          padding: "0 40px 40px 40px",
        },
      }}
    >
      <Modal.Header>
        <Flex w="100%" justify="space-between" align="center">
          <Title order={2}>{title}</Title>
          <Flex justify="center" align="center" gap="8px" mr="4px">
            <Text fw="600">Playlist Abaixo</Text>
            <ArrowDown
              size="32"
              variant="Bold"
              color={theme.colors.primary[0]}
            />
          </Flex>
        </Flex>
        <Modal.CloseButton />
      </Modal.Header>
      <Flex gap="16px" direction={"column"} w="100%" h="100%">
        {children}
      </Flex>
    </ModalMantine>
  );
};

export default ModalVideo;
